import script from "./AppLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLoading.vue?vue&type=script&setup=true&lang=ts"

import "./AppLoading.vue?vue&type=style&index=0&id=23dc36e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23dc36e2"]])

export default __exports__